<template>
    <div>
        <div class="page-help">
            <div class="page-help__title">
                <h1>{{ $t('front.help.titles.help_center') }}</h1>
            </div>
            <div class="page-help__body">
                <div class="container">
                    <div class="page-help__search">
                        <input v-model="searchText" type="text"
                               :placeholder="$t('front.search.form.input_placeholder')">

                        <div class="page-help__search_results"
                             v-if="searchResults.length || searchText && !searchResults.length">
                            <ul v-if="searchResults.length">
                                <li v-for="(item, index) in searchResults" :key="index">
                                    <router-link :to="item.pageUrl">
                                        <span v-text="item.question"/>
                                    </router-link>
                                </li>
                            </ul>
                            <div class="null" v-if="searchText && !searchResults.length">
                                {{ $t('front.help.messages.no_one_item_found') }}
                            </div>
                        </div>

                    </div>
                    <div class="page-help__category">
                        <h2>{{ $t('front.help.titles.popular_topics') }}</h2>
                        <ul>
                            <li v-for="(item, index) in categories" :key="index">
                                <router-link :to="item.pageUrl">
                                    <img :src="item.image" :alt="item.title">
                                    <span v-text="item.title"/>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="page-help__bottom">
                    <div class="container">
                        <h2>{{ $t('front.help.titles.need_more_help') }}</h2>
                        <v-btn @click="supportDialog = true">{{ $t('front.help.button.contact_us') }}</v-btn>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog content-class="dialog-support" v-model="supportDialog" max-width="900px"
                  :persistent="isDialogPersistent">
            <support-popup @close="supportDialog = false" v-if="supportDialog"/>
        </v-dialog>
    </div>
</template>

<script>
import DialogSettings from "../../../../mixins/dialogSettings";
import apiData from "../../../../mixins/apiData";
import eventsInterface from "../../../../interfaces/eventsInterface";

export default {
    name: "HelpCategories",

    components: {DialogSettings},

    mixins: [DialogSettings, apiData],

    data: function () {
        return {
            supportDialog: false,
            searchText: '',
        };
    },

    serverPrefetch() {
        return this.fetchData();
    },

    mounted() {
        this.fetchData();

        void require('../../../../util/analytics/index').trackEvent(eventsInterface.openSupport, this, {
            category: 'Support',
            action: 'Open',
            label: this.user && this.user.partyId || 'Not logged in',
        });
    },

    computed: {
        user() {
            return this.$store.state.user;
        },

        categories() {
            return this.$store.state.helpCategories;
        },

        helpItems() {
            return this.categories.reduce((items, category) => {
                return items.concat(category.items);
            }, []);
        },

        searchResults() {
            if (this.searchText) {
                let lowerSearchText = this.searchText.toLowerCase();

                return this.helpItems.filter(item => item.question && item.question.toLowerCase().includes(lowerSearchText) || item.answer && item.answer.toLowerCase().includes(lowerSearchText));
            } else {
                return [];
            }
        },
    },

    methods: {
        fetchData() {
            return this.$store.dispatch('FETCH_HELP_CATEGORIES', this.createApiData());
        },
    },
}
</script>

<style lang="sass">
@import "sass/components/pages/parts/target/HelpCategories"
</style>